import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { AddFileComponent } from '../../../shared-components/controls/add-file/add-file.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StudentService } from '../../../shared-components/student/student.service';
import { YearService } from '../../../shared-components/year/year.service';
import { StudentDigitalContentService } from '../student-digital-content.service';
import { StudentDigitalContent } from '../models/student-digital-content.model';
import { LookupService } from '../../../shared-components/lookup/lookup.service';
import { Lookup } from '../../../shared-components/lookup/lookup.model';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';

@Component({
    selector: 'add-content-modal',
    templateUrl: './add-content-modal.component.html'
})
export class AddContentModalComponent implements OnInit {

    sdc: StudentDigitalContent;

    documentTypeIdString: string;
    descriptionString: string;
    fileNameString: string;

    newFile: boolean;
    fileError: boolean;
    documentTypes: Lookup[] = [];
    errors: ErrorList[] = [];
    @ViewChild('fileNameInput', { read: ElementRef, static: true }) fileNameInput: ElementRef;
    @ViewChild('documentTypeInput', { read: ElementRef, static: true }) documentTypeInput: ElementRef;
    @ViewChild(AddFileComponent) addFile;


    constructor(private yearService: YearService,
        private lookupService: LookupService,
        private studentDigitalContentService: StudentDigitalContentService,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private studentService: StudentService,
        private dialogRef: MatDialogRef<AddContentModalComponent>) { }

    ngOnInit() {
        this.sdc = this.data.sdc;

        if (this.sdc == undefined) {
            this.sdc = new StudentDigitalContent;
            this.newFile = true;
        }
        else {
            this.documentTypeIdString = this.sdc.DocumentTypeId.toString();
            this.descriptionString = this.sdc.Description;
            this.fileNameString = this.sdc.FileName;
        }

        if (this.studentDigitalContentService.documentTypes.length == 0) {
            this.lookupService.getORFormDocumentType(this.yearService.student360Year.SchoolID).subscribe(result => {
                this.studentDigitalContentService.documentTypes = result;
                this.documentTypes = this.studentDigitalContentService.documentTypes;
            });
        }
        else {
            this.documentTypes = this.studentDigitalContentService.documentTypes;
        }
    }

    saveClick() {
        this.checkInputs();

        if (this.errors.length == 0) {

            this.sdc.DocumentOwnerId = this.studentService.selectedStudent.Id;
            this.sdc.DocumentType = this.documentTypes.find(x => x.Id == this.documentTypeIdString).CodeDescription;
            this.sdc.DocumentTypeId = parseInt(this.documentTypeIdString);
            this.sdc.Description = this.descriptionString;
            this.sdc.FileName = this.fileNameString;

            if (this.newFile) {
                this.sdc.FileExtension = '.' + this.addFile.fileExtension;
                this.sdc.OriginalFileName = this.addFile.fileName;
                this.sdc.MyFileBase64String = this.addFile.fileString;
                this.sdc.FileType = this.addFile.fileType;                
            }

            // save to the database
            this.studentDigitalContentService.saveStudentDigitalContent(this.sdc, this.yearService.student360Year.SchoolID).subscribe(result => {
                if (result > 0) {
                    // Close the dialog
                    this.dialogRef.close(true);
                }
            });
        }
    }

    checkInputs() {
        let isValidFile = true;

        this.errors = [];

        if (this.fileNameString == undefined || this.fileNameString == null || this.fileNameString == '') {
            this.errors.push({
                fieldName: 'File Name',
                fieldRef: this.fileNameInput,
                errorMsg: 'Field is required.'
            });
        }

        if (this.documentTypeIdString == undefined || this.documentTypeIdString == null || this.documentTypeIdString == '') {
            this.errors.push({
                fieldName: 'Document Type',
                fieldRef: this.documentTypeInput,
                errorMsg: 'Field is required.'
            });
        }

        if (this.newFile) {

            if (!this.addFile.hasOwnProperty('fileName')) {
                this.fileError = true;
                isValidFile = false;
            } else {
                if (this.addFile.fileName == null) {
                    this.fileError = true;
                    isValidFile = false;
                } else {
                    this.fileError = false;
                }
            }
        }

        if (!isValidFile) {
            this.errors.push({
                fieldName: 'File',
                fieldRef: null, // this.subjectInput,
                errorMsg: 'Field is required.'
            });
        }
    }

    addFileChanges(event) {
        // check if a file has been selected
        if (this.addFile.hasOwnProperty('fileName')) {
            this.fileError = false;
        }
    }

    closeClick() {
        this.dialogRef.close(false);
    }
}
